import { render } from "./CompanyPolicy.vue?vue&type=template&id=1a9c10be"
import script from "./CompanyPolicy.vue?vue&type=script&lang=js"
export * from "./CompanyPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__